export default "<span class=\"replyCountStyle\" (click)=\"openThreadMessage()\">\r\n  {{ reply }}\r\n</span>\r\n";